<template>
  <div class="p-3 bg-white">
    <shared-consultation-edit-custom-field
      @editCustomFieldSuccess="editCustomFieldSuccess"
    ></shared-consultation-edit-custom-field>
    <div class="text-center">
      <vs-button id="updateConfigurationConsultationCustomFieldButton" class="m-2" color="primary" type="filled" @click.prevent="editCustomField">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import SharedConsultationEditCustomField from '@/views/Shared/Configuration/Consultation/CustomFields/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Configuration.Consultation.CustomField.Edit',
  components: {
    SharedConsultationEditCustomField
  },
  mounted () {
    const id = this.$route.params.id
    EventBus.$emit('initEditCustomField', { id })
  },
  methods: {
    editCustomField () {
      EventBus.$emit('updateCustomField')
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_configuration_consultation_custom_field_table')
      window.close()
    },
    editCustomFieldSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_configuration_consultation_custom_field_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
